import {getRandomId} from '../../helpers/common'


const randomId = store => next => action => {
    if (action.payload && action.payload.generateId) {
        let {...rest} = action.payload
        return next({
            ...action,
            payload : {
                ...rest,
                randomId : getRandomId()
            }
        })
    }
    return next(action)
}

export default randomId


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/middlewares/randomId.js